const EVENT_NAME = {
    /**
     *  分类菜单列表
     */
    DEVICE_MENU_LIST:'DEVICE_MENU_LIST',
    /**
     *  管理目录列表
     */
    ARCHIVE_MENU_LIST:'ARCHIVE_MENU_LIST',
    /**
     *  定位菜单列表
     */
    LOCATION_MENU_LIST:'LOCATION_MENU_LIST',
    /**
     *  账户菜单列表
     */
    ACCOUNT_MENU_LIST:'ACCOUNT_MENU_LIST',
    /**
     * 可能的原因可显示
     */
    REASON_MODAL_VISIBLE:'REASON_MODAL_VISIBLE',
    /**
     * 进度条数值
     */
    UPLOAD_PROGRESS_COMPLETE:'UPLOAD_PROGRESS',
}
export default EVENT_NAME
